import { PointsCloudSystem, SceneLoader, Vector3 } from "@babylonjs/core";
export class Tile3dLoader {
    constructor(scene) {
        this._scene = scene;
    }
}
export class B3DMLoader extends Tile3dLoader {
    constructor(scene) {
        super(scene);
    }
    async loadAsync(url) {
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const { glbData } = this._parseB3DM(arrayBuffer);
        return await this._loadGLBAsync(glbData);
    }
    _parseB3DM(arrayBuffer) {
        const byteOffset = 28;
        const glbData = arrayBuffer.slice(byteOffset);
        return { glbData };
    }
    async _loadGLBAsync(glbData) {
        return new Promise((resolve, reject) => {
            const blob = new Blob([glbData], { type: "model/gltf-binary" });
            const objectURL = URL.createObjectURL(blob);
            SceneLoader.ImportMesh("", objectURL, "", this._scene, (meshes) => {
                URL.revokeObjectURL(objectURL);
                resolve(meshes);
            }, null, (scene, message) => {
                reject(new Error("Failed to load GLB: " + message));
            }, ".glb");
        });
    }
}
export class I3DMLoader extends Tile3dLoader {
    constructor(scene, parent = null) {
        super(scene);
        this._parent = parent;
    }
    async loadAsync(url) {
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const { glbData, instances } = this._parseI3DM(arrayBuffer);
        return await this._loadInstancesAsync(glbData, instances, this._parent);
    }
    _parseI3DM(arrayBuffer) {
        const byteOffset = 32;
        const glbData = arrayBuffer.slice(byteOffset);
        const instances = this._extractInstances(arrayBuffer, byteOffset);
        return { glbData, instances };
    }
    _extractInstances(arrayBuffer, offset) {
        const instanceCount = new DataView(arrayBuffer, offset, 4).getUint32(0, true);
        const instanceData = new Float32Array(arrayBuffer, offset + 4, instanceCount * 12);
        return instanceData;
    }
    async _loadInstancesAsync(glbData, instances, parent = null) {
        const meshes = await new B3DMLoader(this._scene)._loadGLBAsync(glbData);
        const baseMesh = meshes[0];
        for (let index = 0; index < instances.length; index += 12) {
            const clone = baseMesh.clone(`instance_${index / 12}`, null);
            if (clone) {
                clone.position = new Vector3(instances[index], instances[index + 1], instances[index + 2]);
            }
        }
        return meshes;
    }
}
export class PNTSLoader extends Tile3dLoader {
    constructor(scene) {
        super(scene);
    }
    async loadAsync(url) {
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const positions = this._parsePNTS(arrayBuffer);
        return this._createPointCloud(positions);
    }
    _parsePNTS(arrayBuffer) {
        const byteOffset = 28;
        return new Float32Array(arrayBuffer, byteOffset);
    }
    _createPointCloud(positions) {
        const pcs = new PointsCloudSystem("pcs", 1, this._scene);
        for (let i = 0; i < positions.length; i += 3) {
            pcs.addPoints(1, (particle) => {
                particle.position = new Vector3(positions[i], positions[i + 1], positions[i + 2]);
            });
        }
        pcs.buildMeshAsync();
        return pcs.mesh;
    }
}
export class CMPTLoader extends Tile3dLoader {
    constructor(scene) {
        super(scene);
    }
    async loadAsync(url) {
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const tileDataArray = this._parseCMPT(arrayBuffer);
        const promises = tileDataArray.map((tileData) => {
            return this._loadTileAsync(tileData);
        });
        return Promise.all(promises);
    }
    _parseCMPT(arrayBuffer) {
        const byteOffset = 16;
        const tiles = [];
        let offset = byteOffset;
        while (offset < arrayBuffer.byteLength) {
            const tileLength = new DataView(arrayBuffer, offset, 4).getUint32(0, true);
            tiles.push(arrayBuffer.slice(offset, offset + tileLength));
            offset += tileLength;
        }
        return tiles;
    }
    async _loadTileAsync(tileData) {
        return new B3DMLoader(this._scene)._loadGLBAsync(tileData);
    }
}
//# sourceMappingURL=legacy.tile3d.loaders.js.map